'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.capitalize = exports.isSoundcloudURL = exports.isYoutubeURL = exports.isVimeoURL = exports.isURL = undefined;

var _capitalize = require('./transformation/capitalize');

var _capitalize2 = _interopRequireDefault(_capitalize);

var _isURL = require('./validation/isURL');

var _isURL2 = _interopRequireDefault(_isURL);

var _isVimeoURL = require('./validation/isVimeoURL');

var _isVimeoURL2 = _interopRequireDefault(_isVimeoURL);

var _isYoutubeURL = require('./validation/isYoutubeURL');

var _isYoutubeURL2 = _interopRequireDefault(_isYoutubeURL);

var _isSoundcloudURL = require('./validation/isSoundcloudURL');

var _isSoundcloudURL2 = _interopRequireDefault(_isSoundcloudURL);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * String utils for transformation and validation
 * @example
 * import { isUrl } from '@studionand/string-utils';
 * @namespace StringUtils
 */
exports.isURL = _isURL2.default;
exports.isVimeoURL = _isVimeoURL2.default;
exports.isYoutubeURL = _isYoutubeURL2.default;
exports.isSoundcloudURL = _isSoundcloudURL2.default;
exports.capitalize = _capitalize2.default;